import { ToolCallProps } from "../../../types/ToolCall";

type FsReadSliceToolProps = ToolCallProps<{
	path: string;
	start?: number;
	end?: number;
}>;

export function FsReadSliceTool({ status, args }: FsReadSliceToolProps) {
	const path = args?.path ?? "";
	const start = args?.start;
	const end = args?.end;

	if (status === "loading") {
		return (
			<div className="flex items-center gap-2 text-sm text-base-content/50 italic">
				<span className="loading loading-spinner loading-xs" />
				<span className="truncate">Lecture de {path}</span>
				<UnitRange start={start} end={end} />
			</div>
		);
	}

	if (status === "completed") {
		return (
			<div className="flex items-center gap-2 text-sm text-base-content/70 italic">
				<svg
					className="w-4 h-4 flex-shrink-0"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={2}
						d="M5 13l4 4L19 7"
					/>
				</svg>
				<span className="truncate">{path} lu</span>
				<UnitRange start={start} end={end} />
			</div>
		);
	}

	return null;
}

function UnitRange({ start, end }: { start: number | undefined, end: number | undefined }) {
	if (!start && !end) {
		return null;
	}

	if (start && end) {
		return <span className="text-xs text-base-content/50">{start}-{end}</span>;
	}

	if (start) {
		return <span className="text-xs text-base-content/50">{start}-fin</span>;
	}

	return <span className="text-xs text-base-content/50">1-{end}</span>;
}
